/**
 * DeleteNoteConfirm: the confirm before a team note is deleted for good,
 * on an organization's page and on a person's, on the house ConfirmDialog.
 *
 * The caller mounts it when a note is queued; the page offers Delete on a
 * note to its author and to a holder of delete_provider_note, and the
 * server decides again. `error` is a sentence from errorCopy, never a
 * server string.
 */

import { type ReactNode } from 'react';
import { ConfirmDialog } from '@/components/workspace/ConfirmDialog';

export interface DeleteNoteConfirmProps {
  busy: boolean;
  error: string | null;
  /** The error's test id, as each page has named it. */
  errorTestId: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeleteNoteConfirm({ busy, error, errorTestId, onConfirm, onCancel }: DeleteNoteConfirmProps): ReactNode {
  return (
    <ConfirmDialog
      title="Delete this note?"
      body="It can't be brought back."
      confirmLabel="Delete note"
      destructive
      error={error}
      errorTestId={errorTestId}
      busy={busy}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
